module.exports = __webpack_public_path__ + "img/index_04.5cb67422.jpg";